import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { ERTEmergencyResponse } from "../../interfaces/emergencyresponse/emergencyresponse";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ERTMedicalRunSheet } from "../../interfaces/emergencyresponse/medical-runsheet";
import {
  ERTGender,
  RespiratoryType,
  PatientType,
  ConsciousnessLevel,
  SkinCondition,
} from "../../interfaces/emergencyresponse/medical-runsheet-enum";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class ERTMedicalRunSheetService {
  newERTMedicalRunSheet: ERTMedicalRunSheet;
  public ertMedicalRunSheetForm: FormGroup;

  medicalRunSheetId: string;
  dateTimeIncidentOccured: string;
  medicalRunSheetDetails: ERTMedicalRunSheet;

  constructor(private httpClient: HttpClient, private fb: FormBuilder) {
    this.ertMedicalRunSheetForm = this.fb.group({
      dateAndTimeIncidentOccurred: [""],
      location: [""],
      medicalTeam: [""],
      incidentCommander: [""],
      patientName: [""],
      employer: [""],
      patientAge: [""],
      patientGender: [""],
      hospital: [""],
      dateAndTimeOfArrival: [""],
      readiedForNextRun: [false],
      okFuel: [false],
      comments: [""],
      chiefComplaint: [""],
      history: [""],
      assessment: [""],
      treatment: [""],
      equipment: [""],
      respiration: [""],
      dateAndTimeTaken: [""],
      type: [""],
      levelOfCons: [""],
      pupils: [""],
      skin: [""],
      pulseRate: [""],
      pulseType: [""],
      diastolicRate: [""],
      systolicRate: [""],
      medicalSignOff: [""],
    });
  }

  public setERTMedicalRunSheet(data: ERTMedicalRunSheet) {
    this.newERTMedicalRunSheet = { ...this.newERTMedicalRunSheet, ...data };
  }

  public getAllERTMedicalRunSheets() {
    return this.httpClient.get<ERTMedicalRunSheet[]>(
      `${apiHost}/medicalRunSheet`
    );
  }

  public getERTMedicalRunSheetByEmergencyResponseId(
    ertEmergencyResponseId: number
  ) {
    return this.httpClient.get<ERTMedicalRunSheet[]>(
      `${apiHost}/medicalRunSheet/emergencyResponse/${ertEmergencyResponseId}`
    );
  }

  public getERTMedicalRunSheetById(ertMedicalRunSheetId: number, facilityId: number) {
    return this.httpClient.get<ERTMedicalRunSheet>(
      `${apiHost}/medicalRunSheet/${ertMedicalRunSheetId}?loggedInUserFacilityId=${facilityId}`
    );
  }

  public addERTMedicalRunSheet(facilityId: number) {
    return this.httpClient.post(
      `${apiHost}/medicalRunSheet?loggedInUserFacilityId=${facilityId}`,
      this.newERTMedicalRunSheet
    );
  }

  public updateERTMedicalRunSheet(ertMedicalRunSheet: ERTMedicalRunSheet, facilityId: number) {
    return this.httpClient.put(
      `${apiHost}/medicalRunSheet/${ertMedicalRunSheet.id}?loggedInUserFacilityId=${facilityId}`,
      ertMedicalRunSheet
    );
  }

  public deleteERTMedicalRunSheet(ertMedicalRunSheetId: number, facilityId: number) {
    return this.httpClient.delete(
      `${apiHost}/medicalRunSheet/${ertMedicalRunSheetId}?loggedInUserFacilityId=${facilityId}`
    );
  }

  public validateNewERTMedicalRunSheetStep1(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (!formGroup.get("dateAndTimeIncidentOccurred")?.value) {
      validationMessages.push("Date and Time of Incident is required");
    }
    return validationMessages;
  }

  public validateNewERTMedicalRunSheetStep3(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (formGroup.get("respiration")?.value && !formGroup.get("dateAndTimeTaken")?.value) {
      validationMessages.push("Date and Time Taken is required");
    }
    return validationMessages;
  }

  public validateNewErtUserStep2(formGroup: FormGroup): string[] {
    const validationMessages: string[] = [];
    if (!formGroup.get("firstName")?.value) {
      validationMessages.push("First Name is required");
    } else if (!formGroup.get("lastName")?.value) {
      validationMessages.push("Last Name is required");
    }
    return validationMessages;
  }

  validateERTViewForm(ertViewForm: FormGroup): string[] {
    const errors: string[] = [];
    if (!ertViewForm.get("selectedFacility")?.value) {
      errors.push("Facility is required");
    }
    if (!ertViewForm.get("lastName")?.value) {
      errors.push("Last Name is required");
    }
    if (!ertViewForm.get("firstName")?.value) {
      errors.push("First Name is required");
    }
    return errors;
  }

  printMedicalRunSheet(id: string, facilityId: number) {
    this.getERTMedicalRunSheetById(Number(id), facilityId).subscribe((data) => {
      this.medicalRunSheetDetails = data;
      this.dateTimeIncidentOccured = this.formatDate(
        data.dateAndTimeOfIncident?.toString()
      );

      const printWindow = window.open("", "Medical Run Sheet");

      if (printWindow) {
        printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        
        <head>
            <title style="text-align: center">ERT Medical Run Sheet</title>
            <meta charset="utf-8">
        </head>
        
        <body style="font-family: Arial, sans-serif; font-size: 12px; padding: 20px; margin: 0;">
            <main>
              <div style="background-color: white; padding: 20px;">
                <div style="background-color: white; overflow-y: auto; padding: 20px;">
                  <h2 style="text-align: center; padding-top: 10px; margin-bottom: 10px;">Medical Run Sheet</h2>

                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 11%; font-weight: bold; padding-top: 5px;">Date/Time</div>
                    <div style="width: 20.66%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.dateTimeIncidentOccured ?? ""
                    }</div>
                    <div style="width: 1.66%;"></div>
                    <div style="width: 16.66%; font-weight: bold; padding-top: 5px;">Patient Name:</div>
                    <div style="width: 16.66%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.patientName ?? ""
                    }</div>
                    <div style="width: 1.66%;"></div>
                    <div style="width: 15%; font-weight: bold; padding-top: 5px;">Age:</div>
                    <div style="width: 16.66%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.patientAge ?? ""
                    }</div>
                  </div>
              
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 11%; font-weight: bold; padding-top: 5px;">Gender</div>
                    <div style="width: 20.66%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.patientGender !== null &&
                      this.medicalRunSheetDetails?.patientGender !==
                        undefined &&
                      Object.values(ERTGender).includes(
                        this.medicalRunSheetDetails?.patientGender ?? ""
                      )
                        ? ERTGender[
                            this.medicalRunSheetDetails
                              ?.patientGender as unknown as keyof typeof ERTGender
                          ]
                        : ""
                    }</div>
                    <div style="width: 1.66%;"></div>
                    <div style="width: 16.66%; font-weight: bold; padding-top: 5px;">Employer:</div>
                    <div style="width: 50%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.patientEmployer ?? ""
                    }</div>
                  </div>
              
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 16.66%; font-weight: bold; padding-top: 5px;">Medical Team:</div>
                    <div style="width: 83.34%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.medicalTeam ?? ""
                    }</div>
                  </div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px; margin-top: 10px;">Chief Complaint:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.cheifComplaint ?? ""
                  }</div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">History:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.history ?? ""
                  }</div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Assessment:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.assessment ?? ""
                  }</div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Treatment:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.treatment ?? ""
                  }</div>
              
                  <div style="text-align: left; background-color: #d3d3d3; padding: 5px;">Vitals</div>
                  <div style="display: flex; margin-top: 10px; font-weight: bold; background-color: #d3d3d3;">
                    <div style="width: 21.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Date/Time</div>
                    <div style="width: 16.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Respiration</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Pulse Rate</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Pulse Type</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">BP Systolic</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">BP Diastolic</div>
                    <div style="width: 11.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Level of Cons</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">Pupils</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black;">Skin</div>
                  </div>
                  <div style="display: flex; border-bottom: 1px solid black; margin-bottom: 10px;">
                    <div style="width: 21.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.formatDate(
                        this.medicalRunSheetDetails?.dateTimeOfRecord?.toString()
                      ) ?? ""
                    }</div>
                    <div style="width: 16.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.respiratory !== null &&
                      this.medicalRunSheetDetails?.respiratory !== undefined &&
                      Object.values(RespiratoryType).includes(
                        this.medicalRunSheetDetails?.respiratory ?? ""
                      )
                        ? RespiratoryType[
                            this.medicalRunSheetDetails
                              ?.respiratory as unknown as keyof typeof RespiratoryType
                          ]
                        : ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.pulseRate ?? ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.type !== null &&
                      this.medicalRunSheetDetails?.type !== undefined &&
                      Object.values(PatientType).includes(
                        this.medicalRunSheetDetails?.type ?? ""
                      )
                        ? PatientType[
                            this.medicalRunSheetDetails
                              ?.type as unknown as keyof typeof PatientType
                          ]
                        : ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.systolicRate ?? ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.diastolicRate ?? ""
                    }</div>
                    <div style="width: 11.66%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.levelOfConsciousness !==
                        null &&
                      this.medicalRunSheetDetails?.levelOfConsciousness !==
                        undefined &&
                      Object.values(ConsciousnessLevel).includes(
                        this.medicalRunSheetDetails?.levelOfConsciousness ?? ""
                      )
                        ? ConsciousnessLevel[
                            this.medicalRunSheetDetails
                              ?.levelOfConsciousness as unknown as keyof typeof ConsciousnessLevel
                          ]
                        : ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.diastolicPupils ?? ""
                    }</div>
                    <div style="width: 11.11%; padding: 5px; border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black;">&nbsp;${
                      this.medicalRunSheetDetails?.skin !== null &&
                      this.medicalRunSheetDetails?.skin !== undefined &&
                      Object.values(SkinCondition).includes(
                        this.medicalRunSheetDetails?.skin ?? ""
                      )
                        ? SkinCondition[
                            this.medicalRunSheetDetails
                              ?.skin as unknown as keyof typeof SkinCondition
                          ]
                        : ""
                    }</div>
                  </div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Comments:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.comments ?? ""
                  }</div>
              
                  <div style="display: flex; margin-bottom: 10px; padding-top: 10px;">
                    <div style="width: 22%; font-weight: bold; padding-top: 5px;">Hospital:</div>
                    <div style="width: 20%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.patientHospital ?? ""
                    }</div>
                    <div style="width: 8%"> </div>
                    <div style="width: 20%; font-weight: bold; padding-top: 5px;">Arrival Date/Time:</div>
                    <div style="width: 20%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.formatDate(
                        this.medicalRunSheetDetails.dateTimePatientArrival?.toString()
                      ) ?? ""
                    }</div>
                    <div style="width: 10%"> </div>
                  </div>
              
                  <div style="text-align: center; background-color: #d3d3d3; padding: 5px;">Equipment Used:</div>
                  <div style="border: 1px solid black; padding: 5px; margin-bottom: 10px;">&nbsp;${
                    this.medicalRunSheetDetails?.equipment ?? ""
                  }</div>
              
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 22%; font-weight: bold; padding-top: 5px;">Readied for next run?</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.isReadiedForNextRun
                        ? "X"
                        : " "
                    }</div>
                    <div style="width: 26%"> </div>
                    <div style="width: 20%; font-weight: bold; padding-top: 5px;">Fuel?</div>
                    <div style="width: 2%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.isFuelOk ? "X" : " "
                    }</div>
                    <div style="width: 28%"> </div>
                  </div>
              
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 22%; font-weight: bold; padding-top: 5px;">Medical Sign off:</div>
                    <div style="width: 78%; border: 1px solid black; padding: 5px;">&nbsp;${
                      this.medicalRunSheetDetails?.medicalTeam ?? ""
                    }</div>
                  </div>
                </div>
              </div>
            </main>
            <script>
              window.onload = function() {
              window.print();
             }
            </script>
        </body>

        </html>
        `);
        printWindow.document.close();
      } else {
        console.error("Could not open print window");
      }
    });
  }

  formatDate(input: string): string {
    if (input === null || input === undefined) {
      return "";
    }
    const date = new Date(input);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = Number(hours) >= 12 ? "PM" : "AM";
    hours = (Number(hours) % 12).toString().padStart(2, "0");
    hours = Number(hours) ? hours : "12";
    const strTime = `${hours}:${minutes} ${ampm}`;

    return `${month}/${day}/${year} ${strTime}`;
  }
}
